<template>
  <div>
    <modal
        v-if="cartItems.length > 0 && this.$route.name != 'Home'"
        name="cart-items"
        :id="hasKiosk?'cart-items-id':''"
        :width="hasKiosk ? '100%' : '45%'"
        :height="hasKiosk? '100%' : '90%'"
        :adaptive="true"

        :class="[
        'cartItemsModal relative',
        !hasKiosk&&'hidden md:block',
        // hasKiosk? 'noLeftModal' : 'roundedmodal',
        // hasKiosk&& menu.is_square_layout ? 'deleteModalSquare' : 'roundedmodal',
        menu.is_square_layout || hasKiosk ? 'deleteModalSquare' : 'roundedmodal',
        ]"
        @before-open="onBeforeOpen"
        @before-close="closingModal"
        ref="cartModal"
    >
    <div :style="cartHeaderHeight && hasKiosk? 'padding-top: 2rem; padding-bottom: 2rem;' + backgroundMain : ''">
        <div
        v-show="hasKiosk"
        :class="[
            'items-center pt-6 pb-16 px-12 justify-center',
            this.$route.name !== 'Home' ? 'flex pb-6' : '',
            this.$route.name == 'Category' ? 'flex justify-between' : '',
        ]"
        :style="backgroundMain + landingsPageSelectionBackgroundUrl + cartHeaderHeight"
        >
        <!-- arrow back to homescreen -->
        <div
            v-show="
            this.$route.name !== 'OrderDetails' &&
            this.$route.name !== 'Home' &&
            isSwipeOpen != true &&
            !hasKiosk
            "
            class="bg-primary-100 ml-4 rounded-xl self-center"
            :style="btnThirdBackground"
        >
            <a
            @click="
                $router.push({
                path: hasKiosk?`/${menuHash}/${tableId ? tableId : ''}`:`/${menuHash}/${stickerId ? stickerId : ''}`,
                })
            "
            class="flex self-center items-center pl-2 pr-2 w-20"
            >
                <IconBackArrow
                    :fill="buttonImgColors"
                />
            <p
                :class="['text-xs mr-2 text-primary-400']"
                :style="btnThirdText"
            >
                Menu
            </p>
            </a>
        </div>
        <div    
            v-if="hasKiosk"   
            :class="[
                'cursor-pointer',
                menu.is_kiosk_horiz_categ ? '' : 'invisible',
            ]"
            class="cursor-pointer"
        >
            <div
            v-if="
                menu.enable_delivery ||
                (hasKiosk && this.$route.name != 'OrderDetails')
            "
            class="hidden md:block w-full mx-auto"
            >
            <a
                @click="
                hasKiosk
                    ? $router.push({ path: `/${menuHash}/start/kiosk` ,query:$route.query})
                    : $router.push({
                        path: `/${menuHash}/delivery/take-out`,
                    });
                $modal.hide('cart-items');
                "
                class="rounded-xxl w-full flex items-center justify-center"
                :style="makeStyles(headerButtonBackground,languageButtonRadius)"
            >
            <IconTruck
                v-if="currentKioskMode == lang['take_away'][language]"
                :stroke="smallOrderTypeIconColor"
                />
                <IconHome v-else 
                :stroke="smallOrderTypeIconColor"
                />
                <p
                class="ml-4 text-new-primary font-bold pr-6"
                :style="btnThirdText"
                >
                <span v-if="!hasKiosk && currentOption">
                    {{ lang[currentOption][language] }}</span
                >
                <span v-else>{{ currentKioskMode }}</span>
                </p>
            </a>
            </div>
        </div>
        <div
            class="flex pl-4 pr-4"
            v-if="this.$route.params.menuHash != 'L'"
        >
            <div
            :class="[
                'flex',
                this.$route.name !== 'Home'
                ? 'w-full justify-center'
                : 'w-5/6 self-center',
            ]"
            >
            <div
                class="flex flex-row block justify-center pr-4 w-32"
                v-if="this.$route.name == 'Home'"
            >
                <img
                class="h-24 rounded-md object-contain"
                :src="
                    menu.picture_url
                    ? menu.picture_url
                    : require('../assets/images/Menu.Logo.png')
                "
                alt="Logo"
                />
            </div>
            <div class="self-center">
                <div v-if="this.$route.name == 'Home'">
                <p
                    class="text-xxs text-white"
                    :style="(headerMainText, QrMenuAppTitle)"
                >
                    QR MENU APP
                </p>
                </div>
                <div :class="['flex flex-col w-full']">
                <div
                    class="'justify-center flex text-white text-xl"
                    :style="headerMainText"
                    v-if="this.$route.name != 'Home'"
                >
                  <img
                    :class="[
                    'rounded-md object-contain',
                    !hasKiosk&&desktopMode ? 'h-14' : 'h-20',
                    ]"
                    :src="menu.picture_url"
                    v-if="menu.picture_url"
                    alt="Logo"
                    :style="isMobileDevice ? '' : headerLogoHeight"
                  />
                   <p v-else
                    :style="makeStyles(hasKiosk&&titleFont,hasKiosk&&titleTextTransform)"
                   >{{ menu["name" + "_" + language] }}</p>
                </div>
                <p
                    v-if="this.$route.name == 'Home'"
                    class="'justify-center flex text-white text-sm"
                    :style="headerMainText"
                >
                    {{ menu["description" + "_" + language] }}
                </p>
                </div>
            </div>
            </div>
            <div
            class="w-1/6 text-right text-white self-center"
            v-if="this.$route.name == 'Home' && stickerId > 0"
            >
            <p class="text-2xl -mt-1">{{ stickerId }}</p>
            </div>
        </div>
        <div
            v-if="menu.enable_delivery && this.$route.name == 'Home'"
            class="flex justify-between"
        >
            <div class="mt-4 mb-6 w-auto inline-block pl-4">
            <a
            v-if="hasKiosk"
                @click="
                hasKiosk
                    ? $router.push({ path: `/${menuHash}/start/kiosk`,query:$route.query })
                    : $router.push({
                        path: `/${menuHash}/delivery/take-out`,
                    })
                "
                class="rounded-xxl flex items-center justify-center"
                :style="btnThirdBackground"
            >
                <IconTruck
                    v-if="currentKioskMode == lang['take_away'][language]"/>
                <IconHome v-else 
                stroke="#9D9D9D"
                />
                <p class="ml-2 text-new-primary font-bold">
                <span class="pr-4" v-if="!hasKiosk && currentOption">
                    {{ lang[currentOption][language] }}</span
                >
                <span v-else>{{ currentKioskMode }}</span>
                </p>
            </a>
            <a
            v-else
                @click="
                !landingsPageDelivery
                    ? hasKiosk
                    ? $router.push({ path: `/${menuHash}/start/kiosk`,query:$route.query })
                    : $router.push({
                        path: `/${menuHash}/delivery/take-out`,
                        })
                    : ''
                "
                :href="
                landingsPageDelivery
                    ? `https://m.qr-menu.app/L/${landingsPageDelivery}`
                    : ''
                "
                class="rounded-xxl flex items-center justify-center"
                :style="btnThirdBackground"
            >
                <IconBackArrow
                v-if="landingsPageDelivery"
                class=" ml-2"
                    :fill="buttonImgColors"
                />
                <IconTruck
                v-else-if="currentKioskMode == lang['take_away'][language]"/>
                <IconHome v-else 
                stroke="#9D9D9D"
                />
                <p
                v-if="!landingsPageDelivery"
                class="ml-2 text-new-primary font-bold"
                >
                <span class="pr-4" v-if="!hasKiosk && currentOption">
                    {{ lang[currentOption][language] }}</span
                >
                <span v-else>{{ currentKioskMode }}</span>
                </p>
                <p class="pr-4" v-else>
                {{ lang["go_back"][this.language] }}
                </p>
            </a>
            </div>
            <LanguageModal />
        </div>
        <div v-if="!menu.enable_delivery" class="invisible">
            <LanguageModal />
        </div>
        <div v-if="menu.enable_delivery && this.$route.name == 'Category'">
            <LanguageModal />
        </div>
        </div>
        </div>
        <div
        id="modalCart"
        :style="makeStyles(hasKiosk && mainSectionTopRadius , hasKiosk ? mainSubCategorysBackground : (backgroundImage? '' : mainSubCategorysBackground))"
        :class="[
            hasKiosk ? '-mt-10 rounded-t-xxl h-full bg-cover' : 'h-full',
        ]"
        >
        <div v-if="!hasKiosk" class="flex items-center sticky top-0 z-20"
            :style="backgroundImage ? '' : mainSubCategorysBackground">
            <div
            v-if="
                processBarIndex == 1 &&
                menu.is_cups_enabled &&
                menu.cups_product_id > 0
            "
            @click="
                $modal.hide('cart-items');
                $modal.show('cups');
            "
            class="w-full ml-4"
            >
            <IconBackArrow
                v-if="landingsPageDelivery"
                fill="#9D9D9D"
            />

            </div>
            <div
            v-if="processBarIndex != 1"
            @click="previousProcess"
            class="w-full ml-4 mt-4"
            >
            <IconBackArrow
                :class="[
                'cursor-pointer h-8 mr-2 text-new-primary',
                hasKiosk ? 'w-12' : 'w-8',
                ]"
                fill="#9D9D9D"
            />
            </div>
            <div class="flex justify-end mr-4 mt-4 w-full">
            <button
                @click="$modal.hide('cart-items');
                deleteProgress();
                ">
                <IconCancel
                    :stroke="cartDestructiveButtonColor"
                    :fill="cartDestructiveButtonColor"
                    :backgroundColor="cartDestructiveButtonBackgroundColor"        
                    :class="[
                    ' p-1 cursor-pointer',
                    hasKiosk ? 'w-12' : 'w-8', 
                    ]"
                />
            </button>
            </div>
        </div>
        <CartProcess test="app 1" />
        </div>
    </modal>
    <modal
        v-if="cartItems.length > 0 && this.$route.name != 'Home' && !hasKiosk"
        name="cart-items"
        width="100%"
        height="95%"
        :adaptive="true"
        :class="['block md:hidden relative cartItem roundedmodal',
        'HasNOTKiosk',
        // hasKiosk?(menu.is_square_layout ? 'deleteModalSquare' : 'roundedmodal'):'',
        menu.is_square_layout ? 'deleteModalSquare' : 'roundedmodal'
        ]"
        @before-open="$emit('before-open')"
        @before-close="closingModal"
        :scrollable="hasKiosk?true:false"
    >
        <div 
        id="modalCartMobile" 
        class="h-full"
        :style="backgroundImage ? '' : mainSubCategorysBackground">
        <div id="scrolling_div" class="h-full">
            <div 
            class="flex w-full fading fixed z-20  rounded-t-xl h-12"
            :class="[hasKiosk?'pt-4':'items-center md:-mt-4']"
            >
            <div
                v-if="
                processBarIndex == 1 &&
                menu.is_cups_enabled &&
                menu.cups_product_id > 0
                "
                @click="
                $modal.hide('cart-items');
                $modal.show('cups');
                "
                class="w-full ml-4"
            >
            <IconBackArrow
                fill="#9D9D9D"
            />
            </div>
            <div
                v-if="processBarIndex != 1"
                @click="previousProcess"
                class="w-full ml-4"
            >
                <IconBackArrow
                fill="#9D9D9D"
                />
            </div>
            <div class="flex justify-end mr-4 w-full">
            <button 
                @click="$modal.hide('cart-items');
                deleteProgress();
                ">
                <IconCancel
                  class="w-8 p-1 cursor-pointer"
                />
            </button>
            </div>
            </div>
            <CartProcess test="app 2" />
        </div>
        </div>
    </modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import CartProcess from "./CartProcess";
import IconCancel from './icons/iconCancel.vue';
import IconBackArrow from './icons/iconBackArrow.vue';
import IconTruck from './icons/iconTruck.vue';
import IconHome from './icons/iconHome.vue';
import lang from '../lang';
import LanguageModal from './LanguageModal.vue';
export default {
    name: "CartItemsModal",
    components: {
        CartProcess,
        IconCancel,
        IconBackArrow,
        IconTruck,
        IconHome,
        LanguageModal
    },
    data() {
        return {
            lang:lang
        }
    },
    methods: {
        previousProcess() {
            this.$store.commit("updateProcessBarIndex", this.processBarIndex - 1);
            this.$store.commit("updateProcessBarCurrentItem", this.processBarCurrentItem - 2);
            this.$store.commit("deleteProcessStack");
            this.$store.commit("deleteButtonStack");
            this.$store.commit("updateShowPayment", false);
            this.$store.commit("updateProcessCurrentName", this.processStack[this.processStack.length - 1]);
        },
        deleteProgress() {
            this.$store.commit("updateShowPayment", false);
            },
        closingModal() {
            this.$store.commit("Cart/updateIsCartOverviewShow", false);
            if(this.hasKiosk){
                if (document.getElementsByClassName("prev")[0]) {
                document.getElementsByClassName("prev")[0].style.display = "flex";
                document.getElementsByClassName("next")[0].style.display = "flex";
                }
            }
        },
        onBeforeOpen() {
              const interval = setInterval(() => {
                    this.$forceUpdate();
                }, 10);

                setTimeout(() => {
                    clearInterval(interval);
                }, 1000);
        }
    },
    updated(){
                    let cartModal = document.querySelector('.cartItemsModal .vm--modal');
            if (!cartModal) return;

            if (this.hasKiosk) {
                const backgroundColor = this.$store.state.Theme.customThemeVariables["menu-sub-categorys--background"];
                cartModal.style.setProperty('background-color', backgroundColor, 'important');
                if (this.backgroundMainFullImage) cartModal.style.cssText += this.backgroundMainFullImage;
            } 
            else {
                cartModal = document.querySelector('.cartItem .vm--modal');
                if (!this.backgroundImage) {
                    const backgroundColor = this.$store.state.Theme.customThemeVariables["menu-sub-categorys--background"];
                    cartModal.style.setProperty('background-color', backgroundColor, 'important');                
                }
            }
    },
  computed: {
    ...mapGetters([
        "menu",
        "language",
        "hasKiosk",
        "menuHash",
        "desktopMode",
        "isSwipeOpen",
        "processStack",
        "floatButtonLabel",
        "processBarIndex",
        "currentKioskMode",
        "landingsPageDelivery",
        "isMobileDevice",
    ]),
    ...mapGetters("Cart", [
      "cartItems",
      "items",
      "tableId",
    ]),
      ...mapGetters("Theme", [
      "titleFont",
      "titleTextTransform",
      "languageButtonRadius",
      "mainSectionTopRadius",
      "smallOrderTypeIconColor",
      "backgroundMain",
      "cartHeaderHeight",
      "btnThirdBackground",
      "btnThirdText",
      "mainSubCategorysBackground",
      "buttonImgColors",
      "headerMainText",
      "QrMenuAppTitle",
      "landingsPageSelectionBackgroundUrl",
      "headerLogoHeight",
      "backgroundImage",
      "cartDestructiveButtonColor",
      "cartDestructiveButtonBackgroundColor",
          "backgroundMainFullImage",
          "kioskMainText",
      "headerButtonBackground"
    ]),
    }
};
</script>
